import { render, staticRenderFns } from "./NotificationCenter.vue?vue&type=template&id=34b277be&scoped=true&lang=pug&"
import script from "./NotificationCenter.vue?vue&type=script&lang=js&"
export * from "./NotificationCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b277be",
  null
  
)

export default component.exports